<template>
  <div>
      <div class='row align-items-center mb-ten'>
        <div class='col'>
          <ic-tab
              outlined
              @change='tabChange'
              :items="[
              { key: 'bank', text: $t('cashin.bank') },
              { key: 'qpay', text: $t('cashin.qpay') },
              // { key: 'socialpay', text: $t('cashin.socialpay') },
          ]"
          />
        </div>
        <a @click.stop='modalHandler' class='icon-btn close-btn mr-row'>
          <i class='sr sr-close'></i>
        </a>
      </div>
      <template v-if='tabKey === "bank"'>

        <!-- Түр коммент болгов удахгүй буцаана -->

        <!-- <div v-if="main && main.status === 'admin_signed'"> -->
          <!-- <table class='ic-table md mb-ten'> -->
            <!-- <tbody> -->
            <!-- <tr> -->
              <!-- <td>{{ $t('account.bankName') }}</td> -->
              <!-- <td> -->
                <!-- <select class='form-control' v-model='bankSelector'> -->
<!--                  <option value='15'>{{ $t('account.bankGLMT') }}</option>-->
<!--                  <option value='04'>{{ $t('account.bankTDB') }}</option>-->
<!--                  <option value='32'>{{ $t('account.bankXAC') }}</option>-->
                  <!-- <option value='05'>{{ $t('account.bankKhan') }}</option> -->
<!--                  <option value='00'>{{ $t('account.mcsdAccount') }}</option>-->
                <!-- </select> -->
              <!-- </td> -->
            <!-- </tr> -->
            <!-- <tr> -->
              <!-- <td> -->
                <!-- {{ $t('account.accountNumber') }} -->
              <!-- </td> -->
              <!-- <td class='d-flex justify-content-between align-items-center'> -->
                <!-- {{ bankSelector === '00' ? ibanAccount : accounts[bankSelector] }} -->
                <!-- <copy-button class='ml-1' :value="bankSelector === '00' ? ibanAccountNumber : accounts[bankSelector]"/> -->
              <!-- </td> -->
            <!-- </tr> -->
            <!-- <tr> -->
              <!-- <td> -->
                <!-- {{ $t('account.accountName') }} -->
              <!-- </td> -->
              <!-- <td class='d-flex justify-content-between align-items-center'> -->
                <!-- {{  bankSelector === '00' ? customerAccountName : $t('account.brokerName')  }} -->
                <!-- <copy-button class='ml-1' :value=" bankSelector === '00' ? customerAccountName : $t('account.brokerName')"/> -->
              <!-- </td> -->
            <!-- </tr> -->
            <!-- <tr v-if="typeof user !== 'undefined' && user"> -->
              <!-- <td>{{ $t('account.info') }}</td> -->
              <!-- <td class='d-flex justify-content-between align-items-center'> -->
                <!-- {{ user.register_number }}, {{ user.mobilenumber }} -->
                <!-- <copy-button class='ml-1' :value='`${user.register_number}, ${user.mobilenumber}`'/> -->
              <!-- </td> -->
            <!-- </tr> -->
            <!-- </tbody> -->
          <!-- </table> -->
          <!-- <p class='body-2 font-500'>{{ $t('account.description') }}</p> -->
        <!-- </div> -->
        <!-- <div v-else> -->
          <!-- <warning-info :body="warningInfo" :title="'Уучлаарай! Та энэ үйлдлийг хийх боломжгүй'"></warning-info> -->
        <!-- </div> -->
         
      </template>
      <template v-else-if='tabKey === "qpay"'>
        <b-overlay
            :show='qpay.isLoading'
            rounded
            opacity='0.6'
            spinner
            spinner-variant='primary'
            class='recent-trades'
            @hidden='!qpay.isLoading'
        >
          <b-form v-if='!qpay.qr' @submit.prevent='generateInvoice' class='py-3'>
            <b-form-group style='color: var(--text-primary-color)' :label="$t('cashout.amount')">
              <ic-input size='sm' currency :precision="0" :suffix="'₮'" v-model='requestModel.amount'/>
              <div class='error-message' v-show='v$.requestModel.amount.$errors.length'>
                <div>Та 0₮-с их дүнгээр цэнэглэнэ үү</div>
              </div>
              <div class='error-message' v-show='qpay.error'>
                <div>{{ errorMessage ? errorMessage : 'Хүсэлт илгээх үед алдаа гарлаа' }}</div>
              </div>
            </b-form-group>
            <div class='d-flex justify-content-end'>
              <ic-button class='mr-ten' variant='outline-success'>
                {{ $t('account.income') }}
              </ic-button>
            </div>
          </b-form>
          <div v-else-if='qpay.qr' class='text-center'>
            <vue-qr v-if='qpay.qr' :text='qpay.qr' :logoSrc='qpay.logo' :size='250'></vue-qr>
            <p class='p-2'>Та дээрх кодыг интернэт банкны аппликейшн ашиглан уншуулна уу...</p>
            <div class='alert alert-danger mt-3 mb-0 text-left' role='alert'>
              {{ qrFeeWarning }}
            </div>
          </div>
        </b-overlay>
      </template>

      <template v-else-if='tabKey === "socialpay"'>
        <b-overlay
            :show='socialpay.isLoading'
            rounded
            opacity='0.6'
            spinner
            spinner-variant='primary'
            class='recent-trades'
            @hidden='!socialpay.isLoading'
        >
          <b-form v-if='!socialpay.qr' @submit.prevent='generateSocialPayInvoice' class='py-3'>
            <b-form-group style='color: var(--text-primary-color)' :label="$t('cashout.amount')">
              <ic-input size='sm' :precision="0" currency :suffix="'₮'" v-model='requestModel.amount'/>
              <div class='error-message' v-show='v$.requestModel.amount.$errors.length'>
                <div>Та 0₮-с их дүнгээр цэнэглэнэ үү</div>
              </div>
              <div class='error-message' v-show='socialpay.error'>
                <div>{{ errorMessage ? errorMessage : 'Хүсэлт илгээх үед алдаа гарлаа' }}</div>
              </div>
            </b-form-group>
            <div class='d-flex justify-content-end'>
              <ic-button class='mr-ten' variant='outline-success'>
                {{ $t('account.income') }}
              </ic-button>
            </div>
          </b-form>
          <div v-else-if='socialpay.qr' class='text-center'>
            <vue-qr v-if='socialpay.qr' :text='socialpay.qr' :size='250'></vue-qr>
            <p class='p-2'>Та дээрх кодыг SocialPay аппликейшн ашиглан уншуулна уу...</p>
            <div class='alert alert-danger mt-3 mb-0 text-left' role='alert'>
              {{ qrFeeWarning }}
            </div>
          </div>
        </b-overlay>
      </template>
  </div>
</template>

<script>
import CopyButton from '../global/CopyButton/index.vue'
import {mapState} from 'vuex'
import {unformat} from '../../plugins/currency-input/utils'
import useVuelidate from '@vuelidate/core'
import VueQr from 'vue-qr'
import WarningInfo from "../WarningInfo.vue";
import {Accounts} from '../../utils/constants'


export default {
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      bankSelector: '05',
      accounts: Accounts,
      qrFeeWarning: 'Гүйлгээ тус бүрээс 1% -ийн шимтгэл суутгагдахыг анхаарна уу.',
      requestModel: {
        amount: '',
      },
      tabKey: 'bank',
    }
  },
  validations() {
    return {
      requestModel: {
        amount: {
          valid() {
            return (
                unformat(this.requestModel.amount, 0) > 0
            )
          },
        },
      },
    }
  },
  components: {
    WarningInfo,
    CopyButton,
    VueQr,
  },
  computed: {
    ...mapState('common', ['dark']),
    ...mapState('user', ['user']),
    ...mapState('cashin', ['qpay', 'socialpay']),

    errorMessage() {
      if (this.tabKey === 'qpay') {
        if (this.qpay.error && this.qpay.error.response && this.qpay.error.response.data)
          return this.qpay.error.response.data.message
      }
      if (this.tabKey === 'socialpay') {
        if (this.socialpay.error && this.socialpay.error.response && this.socialpay.error.response.data)
          return this.socialpay.error.response.data.message
      }
    },
    contracts() {
      return this.$store.getters['user/contracts']
    },
    ibanAccount() {
      return this.$store.getters['user/iban']
    },
    ibanAccountNumber() {
      return this.ibanAccount.substring(2) ?? ''
    },
    main() {
      return this.contracts.find(contract => contract.type === 'main')
    },
    warningInfo() {
      return this.main && this.main.status === 'user_signed' ? 'Брокероос шалгаж байна. Та түр хүлээнэ үү.' : 'Харилцагч Та "Брокерийн үйлчилгээний гэрээ"-гээ байгуулна уу.'
    },
    customerAccountName() {
      const user = this.$store.getters['user/user']
      return ((user.firstname ?? '') + ' ' + (user.lastname ?? ''));
    }
  },
  watch: {
    'qpay.url': function (value) {
      if (value && this.$mq !== 'desktop') {
        window.location.href = value
      }
    },
    'socialpay.qr': function (value) {
      if (value && this.$mq !== 'desktop') {
        window.location.href = value
      }
    },
  },
  methods: {
    modalHandler() {
      this.requestModel.amount = ''
      this.$store.dispatch('cashin/clearValues')
      this.$emit('closeCashInModal')
    },
    tabChange(key) {
      this.tabKey = key
      this.$store.dispatch('cashin/clearValues')
    },
    async generateInvoice() {
      await this.v$.$validate()
      if (this.v$.$error) {
        return
      }
      const amount = unformat(this.requestModel.amount, 0)
      this.$store.dispatch(
          'cashin/createQPayInvoice',
          amount,
      )
    },
    async generateSocialPayInvoice() {
      await this.v$.$validate()
      if (this.v$.$error) {
        return
      }
      const amount = unformat(this.requestModel.amount, 0)
      this.$store.dispatch(
          'cashin/createSocialPayQr',
          amount,
      )
    },
  },
}

</script>
